import superAdminMenu from './SuperAdmin';
// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [superAdminMenu]
};

export default menuItems;
